import React, { useEffect } from "react";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { Alert, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { usePrestacaoContasState } from "../context/prestacao-contas-context";
import { usePrestacaoContasController } from "../context/prestacao-contas-controller";
import PlainTextArea from "../../../components/plain-text-area";
import { PrestacaoContasDocumentosSection } from "./prestacao-contas-documentos-section";

export const PrestacaoContasForm = () => {
    const { dataRequest, tiposList } = usePrestacaoContasState();
    const { handleOnChangeForm, loadLookups, getTipoSelecionado } = usePrestacaoContasController();
    const isExistingRecord = dataRequest?.id !== undefined && dataRequest?.id !== null;
    const tipoSelecionado = getTipoSelecionado();

    useEffect(() => {
        (async () => {
            await loadLookups();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const bimestres = [1, 2, 3, 4, 5, 6];
    const quadrimestres = [1, 2, 3];
    const trimestres = [1, 2, 3, 4];

    return (
        <React.Fragment>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Grid container spacing={2}>
                    <Grid item lg={12} sm={12} xl={12}>
                        <Alert severity="info">
                            Os campos disponíveis se ajustam conforme o Tipo de Documento selecionado (bimestral, quadrimestral, anual ou quadrienal).
                        </Alert>
                    </Grid>

                    <Grid item lg={6} sm={6} xl={6}>
                        <InputLabel>Tipo de Documento *</InputLabel>
                        <Select
                            size="small"
                            error={!dataRequest?.idTipoDocumentoPrestacaoContas}
                            value={dataRequest?.idTipoDocumentoPrestacaoContas ?? ''}
                            onChange={(e) => handleOnChangeForm('idTipoDocumentoPrestacaoContas', e.target.value)}
                            fullWidth
                        >
                            <MenuItem value={''} key={0}><em>Selecionar</em></MenuItem>
                            {tiposList?.slice().sort((a, b) => a.name.localeCompare(b.name, 'pt-BR')).map((t) => <MenuItem value={t.id} key={t.id}>{t.name}</MenuItem>)}
                        </Select>
                    </Grid>

                    <Grid item lg={3} sm={3} xl={3}>
                        <InputLabel>Ano *</InputLabel>
                        <Select
                            size="small"
                            error={!dataRequest?.ano}
                            value={dataRequest?.ano ?? ''}
                            onChange={(e) => handleOnChangeForm('ano', e.target.value)}
                            fullWidth
                        >
                            <MenuItem value={''} key={0}><em>Selecionar</em></MenuItem>
                            {Array.from({ length: 12 }, (_, i) => 2020 + i).map((y) => <MenuItem value={y} key={y}>{y}</MenuItem>)}
                        </Select>
                    </Grid>

                    {tipoSelecionado?.indPeriodicidade === 4 && (
                        <Grid item lg={3} sm={3} xl={3}>
                            <InputLabel>Ano Fim (vigência) *</InputLabel>
                            <Select
                                size="small"
                                error={!dataRequest?.anoFim || (dataRequest?.ano != null && dataRequest.anoFim < dataRequest.ano)}
                                value={dataRequest?.anoFim ?? ''}
                                onChange={(e) => handleOnChangeForm('anoFim', e.target.value)}
                                fullWidth
                            >
                                <MenuItem value={''} key={0}><em>Selecionar</em></MenuItem>
                                {Array.from({ length: 12 }, (_, i) => 2020 + i).map((y) => <MenuItem value={y} key={y}>{y}</MenuItem>)}
                            </Select>
                        </Grid>
                    )}

                    {tipoSelecionado?.indPeriodicidade === 2 && (
                        <Grid item lg={3} sm={3} xl={3}>
                            <InputLabel>Bimestre *</InputLabel>
                            <Select
                                size="small"
                                error={!dataRequest?.periodo}
                                value={dataRequest?.periodo ?? ''}
                                onChange={(e) => handleOnChangeForm('periodo', e.target.value)}
                                fullWidth
                            >
                                <MenuItem value={''} key={0}><em>Selecionar</em></MenuItem>
                                {bimestres.map((b) => <MenuItem value={b} key={b}>{b}º Bimestre</MenuItem>)}
                            </Select>
                        </Grid>
                    )}

                    {tipoSelecionado?.indPeriodicidade === 3 && (
                        <Grid item lg={3} sm={3} xl={3}>
                            <InputLabel>Quadrimestre *</InputLabel>
                            <Select
                                size="small"
                                error={!dataRequest?.periodo}
                                value={dataRequest?.periodo ?? ''}
                                onChange={(e) => handleOnChangeForm('periodo', e.target.value)}
                                fullWidth
                            >
                                <MenuItem value={''} key={0}><em>Selecionar</em></MenuItem>
                                {quadrimestres.map((q) => <MenuItem value={q} key={q}>{q}º Quadrimestre</MenuItem>)}
                            </Select>
                        </Grid>
                    )}

                    {tipoSelecionado?.indPeriodicidade === 5 && (
                        <Grid item lg={3} sm={3} xl={3}>
                            <InputLabel>Trimestre *</InputLabel>
                            <Select
                                size="small"
                                error={!dataRequest?.periodo}
                                value={dataRequest?.periodo ?? ''}
                                onChange={(e) => handleOnChangeForm('periodo', e.target.value)}
                                fullWidth
                            >
                                <MenuItem value={''} key={0}><em>Selecionar</em></MenuItem>
                                {trimestres.map((t) => <MenuItem value={t} key={t}>{t}º Trimestre</MenuItem>)}
                            </Select>
                        </Grid>
                    )}

                    <Grid item lg={3} sm={3} xl={3}>
                        <InputLabel>Status *</InputLabel>
                        <Select
                            size="small"
                            error={dataRequest?.indStatus === null || dataRequest?.indStatus === undefined}
                            value={dataRequest?.indStatus ?? ''}
                            onChange={(e) => handleOnChangeForm('indStatus', e.target.value)}
                            fullWidth
                        >
                            <MenuItem value={''} key={0}><em>Selecionar</em></MenuItem>
                            <MenuItem value={1}>Em Execução</MenuItem>
                            <MenuItem value={2}>Finalizado</MenuItem>
                        </Select>
                    </Grid>

                    <Grid item lg={12} sm={12} xl={12}>
                        <InputLabel>Descrição *</InputLabel>
                        <PlainTextArea
                            size="small"
                            rows={3}
                            error={!dataRequest?.textoDescricao}
                            value={dataRequest?.textoDescricao || ''}
                            onChange={(e: any) => handleOnChangeForm('textoDescricao', e.target.value)}
                            fullWidth
                        />
                    </Grid>

                    <Grid item lg={4} sm={4} xl={4}>
                        <InputLabel>Data de Publicação *</InputLabel>
                        <DesktopDatePicker
                            format='DD/MM/YYYY'
                            slotProps={{ textField: { fullWidth: true, size: "small", error: !dataRequest?.dtaPublicacao } }}
                            value={dataRequest?.dtaPublicacao ? dayjs(dataRequest.dtaPublicacao) : null}
                            onChange={(value: Dayjs | null) => handleOnChangeForm('dtaPublicacao', value?.toISOString())}
                        />
                    </Grid>

                    {isExistingRecord ? (
                        <PrestacaoContasDocumentosSection />
                    ) : (
                        <Grid item lg={12} sm={12} xl={12}>
                            <Alert severity="info">
                                Salve o registro primeiro para liberar o cadastro de Documentos.
                            </Alert>
                        </Grid>
                    )}
                </Grid>
            </LocalizationProvider>
        </React.Fragment>
    );
};
